import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { categoriasPlatillos, PlatilloModel } from 'src/app/models/platillo.model';
import { AbstractControl, FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DocumentsService } from 'src/app/services/document.service';
import Swal from 'sweetalert2';
import { Chart, ChartOptions, registerables } from 'chart.js';
import { SuplementosDComponent } from './suplementos-d/suplementos-d.component';
import { AlimentosDComponent } from './alimentos-d/alimentos-d.component';
import { AlimentosPreparadosDComponent } from "./alimentos-preparados-d/alimentos-preparados-d.component";
import { UtilsService } from 'src/app/services/utils.service';
import { Dimensions, ImageCroppedEvent } from 'ngx-image-cropper';
import { ImageCropperModule } from 'ngx-image-cropper';
import { UploadService } from 'src/app/services/upload.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
Chart.register(...registerables)
declare var $: any;


@Component({
  selector: 'app-constructor-dietas',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ImageCropperModule,
    SuplementosDComponent,
    AlimentosDComponent,
    AlimentosPreparadosDComponent
],
  templateUrl: './constructor-dietas.component.html',
  styleUrl: './constructor-dietas.component.css'
})
export class ConstructorDietasComponent implements OnInit {
  userInfo: any;
  env: any = environment
  clienteId: string;
  programaId: string;
  periodoId: any;
  detalleCliente: any;
  detallePrograma: any;

  listaProgramas: any;
  listaInactivos: any;
  detalleActivo: any = {};
  dietasPeriodoActivo: any = [];
  periodosProgramaActivo: any = [];
  filtroPeriodoInactivo: any = 0;
  filtroPeriodoActivo: any = 0;
  filtroProgramaInactivo: any = 0;

  formPlatillos: FormGroup;
  formConstructorDieta: FormGroup;

  listaPlatillos: PlatilloModel[] = [];
  listaPlatillosPropios: PlatilloModel[] = [];
  categoriasPlatillos: any = categoriasPlatillos;

  chartDietaInstance: Chart | null = null;
  chartPlatilloDietaInstance: Chart | null = null;
  patternPlatillos: string = 'platillo'
  filtroCategoriaPlatillo = '';
  filtroPropietario = 'todos'

  listaDietasOriginal: any[] = [];
  listaDietas: any[] = [];
  patternDietas: string = 'dieta'

  dataPlatillo: any = {
    nombre: '',
    categoria: '',
  }

  // DataTables implementadas
  dataTablePlatillos: any;
  dataTableDietas: any;
  dataTableConstructorDieta: any;

  programacionComidaSelected: any = 0;
  
  // Propiedades para manejar las imágenes de cada comida
  imageStates: {[key: number]: {
    imageChangedEvent: any;
    croppedImage: string;
    bolCroppedImg: boolean;
    rawFile: any;
    previewUrl: string | null;
  }} = {};

  constructor(
    private fb: FormBuilder,
    private documentService: DocumentsService,
    private utilsService: UtilsService,
    private uploadService: UploadService,
    private route: ActivatedRoute,
    private router: Router
  ){
    // Object.assign(this, { single });

    this.formPlatillos = this.fb.group
    ({
      items: this.fb.array([]),
    })
    this.formConstructorDieta = this.fb.group({
      nombre: ['', [Validators.required]], // Nombre de la dieta
      programacionComidas: this.fb.array([]), // Array de programación de comidas,
      calorias: [0],
      carbohidratos: [0],
      proteinas: [0],
      grasas: [0]
    });
    this.inicializarProgramacionComidas();
    
  }
  
  ngOnInit(): void {
    $('#sidebar-overlay').click();

    this.userInfo = JSON.parse(localStorage.getItem('userData'));
    
    this.route.paramMap.subscribe(params => {
      this.clienteId = params.get('clienteId');
      this.programaId = params.get('programaId');
      this.periodoId = params.get('periodoId');
      console.log(this.clienteId, this.programaId, this.periodoId);
      if(this.clienteId) {
        this.getDetalleCliente();
        this.filtroPeriodoActivo = this.periodoId-1;
      } else if(this.programaId) {
        this.getProgramas();
        this.getDetallePrograma(this.programaId);
        this.filtroPeriodoActivo = this.periodoId-1;
      }
    });

    this.getPlatillos();
    this.getDietas();
    this.inicializarDataTableConstructorDieta();
    this.generarHorarios();
  }

  isCollapsedAlimentos = false;
  toggleCollapseAlimentos() {
    this.isCollapsedAlimentos = !this.isCollapsedAlimentos;
  }
  isCollapsedConstructor = false;
  toggleCollapseConstructor() {
    this.isCollapsedConstructor = !this.isCollapsedConstructor;
  }
  isLargeScreen: boolean = window.innerWidth > 991;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isLargeScreen = event.target.innerWidth > 991;
  }
  navigateBack() {
    sessionStorage.setItem('seccion', 'calendario');
    sessionStorage.setItem('subseccion', 'dietas');
    sessionStorage.setItem('seccionPeriodoId', this.filtroPeriodoActivo);
    if(this.clienteId) { //'expediente cliente'
      sessionStorage.setItem('seccionProgramaId', this.programaId);
      this.router.navigate(['trainer/config-programa', this.detalleCliente.documentId])
    } else { //'programa prediseñado'
      this.router.navigate(['trainer/config-programa', this.programaId])
    }
  }
  horarios: string[] = [];
  generarHorarios(): void {
    const startHour = 5; // Hora de inicio
    const endHour = 22; // Hora de fin
    const interval = 30; // Intervalo en minutos
  
    for (let hour = startHour; hour <= endHour; hour++) {
      this.horarios.push(`${hour}:00`);
      if (hour !== endHour) {
        this.horarios.push(`${hour}:30`);
      }
    }
  }
  
  /**************************************************/
  /*************** GET's Informacion ****************/
  getPlatillos()
  {
    const filters: any = {
      //"documentContainerId": this.userInfo.documentContainerId,
      //"empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);
    
    if(this.filtroCategoriaPlatillo != '') {
      filtersQuery.push({
        "match_phrase": {
          "categoria.keyword": this.filtroCategoriaPlatillo
        }
      });
    }
    let should: any = []
    switch (this.filtroPropietario){
      case 'todos':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          },
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          }
        ]
        break;
      case 'empresaBase':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.env.empresaBaseId
            }
          }
        ]
        break;
      case 'propios':
        should = [
          {
            "match_phrase": {
              "documentContainerId.keyword": this.userInfo.documentContainerId
            }
          }
        ]
        break;
    }
    filtersQuery.push(
        {
          "bool": { should }
        }
    )
    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(environment.businessId, this.patternPlatillos, query).subscribe({
        next: (data: any) => {
          console.log('listaPlatillos', data)
          if(this.dataTablePlatillos) {
            this.dataTablePlatillos.destroy();
            this.dataTablePlatillos = null; // Eliminar la referencia
          }
          this.listaPlatillos = [];
          this.listaPlatillos = data;
          this.setFormPlatillos();

          // Setea lista de platillos propios
          if(this.filtroPropietario == 'todos' || this.filtroPropietario == 'propios') {
            this.listaPlatillosPropios = this.listaPlatillos.filter(p => p.propietario == this.userInfo.documentContainerId && !p.guiaId);
            // console.log('listaPlatillosPropios', this.listaPlatillosPropios)
          }
        },
        error: (error: any) => {
          console.error(error);
          this.setFormPlatillos();
        }
      });
    }, 1500);
  }
  setFormPlatillos()
  {
    const arreglo = this.formPlatillos.get('items') as FormArray;
    // Vacía el FormArray eliminando todos los controles
    while (arreglo.length !== 0) {
      arreglo.removeAt(0);
    }

    for(let platillo of this.listaPlatillos)
    {
      const grupo = this.fb.group({
        // pla_asignado: [false, [Validators.required]], //cambia el valor del checkbox

        nombre: platillo.nombre,
        categoria: platillo.categoria,
        descripcion: platillo.descripcion,
        imagenUrl: platillo.imagen ? platillo.imagen.url : null,
        // elementos: platillo.elementos,
        cal: platillo.calorias,
        gC: platillo.carbohidratos, // Gramos de carbohidratos
        gP: platillo.proteinas, // Gramos de proteínas
        gG: platillo.grasas, // Gramos de grasas
        propietario: platillo.propietario,
        objInfo: platillo // Guarda todo el objeto del platillo
      })
      arreglo.push(grupo);
    }
    this.inicializarDataTablePlatillos();
  }
  getDietas()
  {
    this.documentService.getDocumentsByType(
      environment.businessId, this.userInfo.documentContainerId, 'dieta').subscribe((res: any) => {
      // console.log('listaDietas', res)
      this.listaDietas = res.content;
      for(let dieta of this.listaDietas) {
        let porcentajesDieta = {
          carbohidratos: 0,
          proteinas: 0,
          grasas: 0
        }
        porcentajesDieta.carbohidratos = ((dieta.carbohidratos * 4) / dieta.calorias) * 100 || 0;
        porcentajesDieta.proteinas = ((dieta.proteinas * 4) / dieta.calorias) * 100 || 0;
        porcentajesDieta.grasas = ((dieta.grasas * 9) / dieta.calorias) * 100 || 0;
    
    
        let sumaPorcentajesDieta = porcentajesDieta.carbohidratos + porcentajesDieta.proteinas + porcentajesDieta.grasas;
        porcentajesDieta.carbohidratos = (porcentajesDieta.carbohidratos / sumaPorcentajesDieta) * 100;
        porcentajesDieta.proteinas = (porcentajesDieta.proteinas / sumaPorcentajesDieta) * 100;
        porcentajesDieta.grasas = (porcentajesDieta.grasas / sumaPorcentajesDieta) * 100;
        dieta.porcentajes = porcentajesDieta;
      }
      this.listaDietasOriginal = structuredClone(this.listaDietas);

      this.inicializarDataTableDietas();
      this.listaDietas = this.listaDietas.filter(d => d.activo == true && !d.programaId);

      console.log('listaDietas', this.listaDietas)
      console.log('listaDietasOriginal', this.listaDietasOriginal)

      this.filtroPeriodoActivo = this.filtroPeriodoActivo;
      console.log('filtroPeriodoActivo', this.filtroPeriodoActivo)
    }, err => {
      console.error(err)
    })
  }
  getDetalleCliente()
  {
    this.documentService.getDocumentById(environment.businessId, this.userInfo.documentContainerId, this.clienteId).subscribe((res: any) => {
      console.log('detalleCliente', res)
      this.detalleCliente = res;

      this.listaInactivos = [];
      this.detalleActivo = {};

      const programasCliente = this.detalleCliente.expediente?.programas;
      const index = programasCliente.findIndex((p) => p.configuracionPrograma.id == this.programaId);
      if(index != -1) {
        this.detallePrograma = programasCliente[index];

        this.detalleActivo = programasCliente[index].periodos[this.filtroPeriodoActivo];
        this.periodosProgramaActivo = programasCliente[index].periodos ? [...programasCliente[index].periodos] : [];
        this.dietasPeriodoActivo = programasCliente[index].periodos[this.filtroPeriodoActivo].dietas ? programasCliente[index].periodos[this.filtroPeriodoActivo].dietas : [];
      }
      for(let programa of programasCliente) {
        if(programa.configuracionPrograma.id != this.programaId) {
          this.listaInactivos.push(programa);
        }
      }
      this.inicializarDataTableDietasActivas();
      this.inicializarDataTableDietasInactivas();
    }, err => {
      console.error(err)
    })
  }
  getProgramas() {
    this.documentService.getDocumentsByType(
      environment.businessId,
      this.userInfo.documentContainerId,
      "programa"
    ).subscribe({
      next: (data: any) => {
        this.listaProgramas = data.content;
        // Dejar solo los programas de tipo '2'
        this.listaProgramas = this.listaProgramas.filter(p => p.tipo == 2);
        // console.log('listaProgramas', this.listaProgramas)

        this.listaInactivos = [];
        for(let programa of this.listaProgramas) {
          if(programa.documentId != this.programaId) {
            this.listaInactivos.push(programa);
          }
        }
        this.inicializarDataTableDietasInactivas();
      },
      error: (error) => {
        console.log(error);
      }
    })
  }
  getDetallePrograma(documentId)
  {
    this.documentService.getDocumentById(environment.businessId, this.userInfo.documentContainerId, documentId).subscribe((res: any) => {
      console.log('detallePrograma', res)
      this.detallePrograma = res;
      this.periodosProgramaActivo = this.detallePrograma.periodos ? [...this.detallePrograma.periodos] : [];
      this.onChangeDietasPeriodoSelected(this.filtroPeriodoActivo);
    }, err => {
      console.error(err)
    })
  }
  
  onChangeDietasPeriodoSelected(id) {
    this.filtroPeriodoActivo = Number(id);
    this.dietasPeriodoActivo = this.detallePrograma.periodos[this.filtroPeriodoActivo].dietas ? [...this.detallePrograma.periodos[this.filtroPeriodoActivo].dietas] : [];
    this.inicializarDataTableDietasActivas();
  }

  /**************************************************/
  /************* Inicializar DataTables *************/
  inicializarDataTablePlatillos()
  {
    if (this.dataTablePlatillos) {
      this.dataTablePlatillos.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTablePlatillos = $('#dataTable-listaPlatillos').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }
  inicializarDataTableDietas()
  {
    if (this.dataTableDietas) {
      this.dataTableDietas.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTableDietas = $('#dataTable-listaDietas').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }
  inicializarDataTableConstructorDieta()
  {
    if (this.dataTableConstructorDieta) {
      this.dataTableConstructorDieta.destroy(); // Destruye cualquier instancia previa
      this.dataTableConstructorDieta = null; // Asegúrate de limpiar la referencia
    }
    $(document).ready(() => {
      this.dataTableConstructorDieta = $('#dataTable-constructorPlatillo').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }
  dataTableDietasInactivas: any;
  inicializarDataTableDietasInactivas() {
    if (this.dataTableDietasInactivas) {
      this.dataTableDietasInactivas.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTableDietasInactivas = $('#dataTable-listaDietasInactivas').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }
  dataTableDietasActivas: any;
  inicializarDataTableDietasActivas() {
    this.filtroPeriodoActivo = this.filtroPeriodoActivo
    console.log('this.filtroPeriodoActivo', this.filtroPeriodoActivo)
    if (this.dataTableDietasActivas) {
      this.dataTableDietasActivas.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTableDietasActivas = $('#dataTable-listaDietasActivas').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }

  /**************************************************/
  /****** Funciones para configurar una dieta *******/
  /**************************************************/

  // inicializa formArray programacionComidas del formulario constructorDieta
  inicializarProgramacionComidas() {
    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    programacionComidasArray.clear();
    
    for (let i = 0; i < 5; i++) {
      // Inicializar estado de imagen para esta comida
      this.imageStates[i] = {
        imageChangedEvent: '',
        croppedImage: '',
        bolCroppedImg: false,
        rawFile: null,
        previewUrl: null
      };

      let programacionComida = this.fb.group({
        nombre: [''],
        hora: ['5:00'],
        descripcion: [''],
        calorias: [0],
        carbohidratos: [0],
        proteinas: [0],
        grasas: [0],
        imagen: [null],
        detalle: this.fb.array([])
      });

      programacionComidasArray.push(programacionComida);
    }
  }
  // inicializa el formConstructorDieta
  limpiarFormConstructorDieta(initDatatable: boolean) {
    // Limpiar el formulario constructorDieta
    this.formConstructorDieta.reset({
      nombre: '',
      programacionComidas: this.fb.array([]),
      calorias: 0,
      carbohidratos: 0,
      proteinas: 0,
      grasas: 0
    });
    this.inicializarProgramacionComidas();
    this.calculoCaloriasPlatilloDieta();
    this.inicializarChart();
    if(initDatatable) this.inicializarDataTableConstructorDieta();
  }

  editarDieta: any = false;
  goEditarDieta(dieta: any, tabDietas: boolean) {
    if(tabDietas) this.editarDieta = structuredClone(dieta);
    if(!tabDietas) {
      // busca el documentId en lista de dietas
      const index = this.listaDietasOriginal.findIndex(d => d.documentId == dieta.documentId);
      if(index != -1) {
        this.editarDieta = structuredClone(this.listaDietasOriginal[index]);
      }
    }
    this.limpiarFormConstructorDieta(false);
    this.formConstructorDieta.patchValue({
      ...this.editarDieta
    });
    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    for(let i = 0; i < this.editarDieta.programacionComidas.length; i++) {
      programacionComidasArray.at(i).patchValue({
        ...this.editarDieta.programacionComidas[i]
      });
      const detalleArray = programacionComidasArray.at(i).get('detalle') as FormArray;
      for(let j = 0; j < this.editarDieta.programacionComidas[i].detalle.length; j++) {
        detalleArray.push(this.crearIngrediente(this.editarDieta.programacionComidas[i].detalle[j]));
      }

      this.imageStates[i].previewUrl = this.editarDieta.programacionComidas[i].imagen?.url || null;
    }
    this.calculoCaloriasPlatilloDieta();
    this.inicializarDataTableConstructorDieta();
  }

  // Se setea el index de la programacionComida seleccionada
  setProgramacionComidaSelected(index: number) {
    this.programacionComidaSelected = index;
    this.inicializarDataTableConstructorDieta();
    this.calculoCaloriasPlatilloDieta();
  }

  // Agrega los ingredientes del platillo al detalle de la comida seleccionada
  agregarIngredientesDePLatillo(platillo: any){
    for(let ingrediente of platillo.detalle){
      this.agregarIngrediente(ingrediente, false, false);
    }
    this.calculoCaloriasPlatilloDieta();
    this.inicializarDataTableConstructorDieta();
  }

  // Agrega nuevo ingrediente/comida libre al detalle de la comida seleccionada
  agregarIngrediente(ingrediente: any, inicializarData: boolean, isComidaLibre: boolean): void {
    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    const detalleArray = programacionComidasArray.at(this.programacionComidaSelected).get('detalle') as FormArray;

    if(!isComidaLibre) {
      // Verifica si el ingrediente ya existe en el detalle de la comida seleccionada
      const index = detalleArray.value.findIndex(d => 
        d.nombre === ingrediente.nombre &&
        d.documentId === ingrediente.documentId
      );
      if (index !== -1) {
        Swal.fire({
          toast: true, // Activa el estilo tipo Toast
          position: 'bottom-end', // Posición del mensaje
          icon: 'warning',
          title: 'El ingrediente ya existe en el platillo.',
          showConfirmButton: false,
          timer: 3000, // Tiempo de duración del mensaje (3 segundos)
          timerProgressBar: true // Muestra una barra de progreso
        });
        return;
      }

      // Verifica que no exista comida libre
      const comidaLibreIndex = detalleArray.value.findIndex(d => d.nombre === 'Comida Libre');
      if (comidaLibreIndex !== -1) {
        // detalleArray.removeAt(comidaLibreIndex);
        Swal.fire({
          toast: true, // Activa el estilo tipo Toast
          position: 'bottom-end', // Posición del mensaje
          icon: 'warning',
          title: 'No se pueden agregar alimentos a una COMIDA LIBRE.',
          showConfirmButton: false,
          timer: 5000, // Tiempo de duración del mensaje (3 segundos)
          timerProgressBar: true // Muestra una barra de progreso
        });
        return;
      }

      // Si no existe, lo agrega
      detalleArray.push(this.crearIngrediente(ingrediente));
    } else {
      // Solo se agrega comida libre mientras el platillo no tenga alimentos
      if(detalleArray.value.length > 0) {
        Swal.fire({
          toast: true, // Activa el estilo tipo Toast
          position: 'bottom-end', // Posición del mensaje
          icon: 'warning',
          title: 'No se puede agregar una COMIDA LIBRE a un platillo que ya tiene alimentos.',
          showConfirmButton: false,
          timer: 5000, // Tiempo de duración del mensaje (3 segundos)
          timerProgressBar: true // Muestra una barra de progreso
        });
        return;
      }
      // Si no existe, lo agrega
      programacionComidasArray.at(this.programacionComidaSelected).patchValue({nombre: 'Comida Libre'});
      
      detalleArray.push(this.crearComidaLibre());
      this.inicializarDataTableConstructorDieta();
    }
    if(inicializarData) {
      this.calculoCaloriasPlatilloDieta();
      this.inicializarDataTableConstructorDieta();
    }
  }
  crearComidaLibre(): FormGroup {
    let detalle = this.fb.group({
      nombre: 'Comida Libre',
      porcionPlatillo: 1,
      calorias: 0,
      carbohidratos: 0,
      proteinas: 0,
      grasaTotal: 0,
      // porcionOriginal: 0,
      caloriasPlatillo: 0,
      carbohidratosPlatillo: 0, // Gramos de carbohidratos
      proteinasPlatillo: 0, // Gramos de proteínas
      grasaTotalPlatillo: 0, // Gramos de grasas
    });
    detalle.get('porcionPlatillo').disable();
    return detalle;
  }
  crearIngrediente(ingrediente: any): FormGroup {
    const grupo =  this.fb.group({
      ...ingrediente, // Propiedades del ingrediente
      porcionPlatillo: [ingrediente.porcion || 0, [Validators.required]], // Unidad del ingrediente
      // porcionOriginal: ingrediente.porcion,
      caloriasPlatillo: ingrediente.calorias,
      carbohidratosPlatillo: ingrediente.carbohidratos, // Gramos de carbohidratos
      proteinasPlatillo: ingrediente.proteinas, // Gramos de proteínas
      grasaTotalPlatillo: ingrediente.grasaTotal, // Gramos de grasas
    });
    grupo.get('porcionPlatillo').valueChanges.subscribe((value: number) => {
      grupo.patchValue({
        caloriasPlatillo: (value * Number(grupo.get('calorias').value)) / Number(grupo.get('porcion').value),
        carbohidratosPlatillo: (value * Number(grupo.get('carbohidratos').value)) / Number(grupo.get('porcion').value),
        proteinasPlatillo: (value * Number(grupo.get('proteinas').value)) / Number(grupo.get('porcion').value),
        grasaTotalPlatillo: (value * Number(grupo.get('grasaTotal').value)) / Number(grupo.get('porcion').value)
      })
      this.calculoCaloriasPlatilloDieta();
    });
    return grupo;
  }
  
  eliminarIngrediente(indexComida: number, indexIngrediente: number): void {
    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    const detalleArray = programacionComidasArray.at(indexComida).get('detalle') as FormArray;
  
    detalleArray.removeAt(indexIngrediente);
    this.inicializarDataTableConstructorDieta();
    this.calculoCaloriasPlatilloDieta();
  }

  limpiarPlatilloDieta() {
    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    const detalleArray = programacionComidasArray.at(this.programacionComidaSelected).get('detalle') as FormArray;
    detalleArray.clear(); // Limpia el array antes de inicializar

    programacionComidasArray.at(this.programacionComidaSelected).patchValue({
      nombre: '',
      hora: '5:00',
      descripcion: '',
      calorias: 0,
      carbohidratos: 0,
      proteinas: 0,
      grasas: 0,
    });
    this.calculoCaloriasPlatilloDieta();
    this.inicializarDataTableConstructorDieta();
  }

  calculoCaloriasPlatilloDieta() {
    let calculoPlatillo = {
      calorias: 0,
      carbohidratos: 0,
      proteinas: 0,
      grasas: 0
    }
    let calculoDieta = {
      calorias: 0,
      carbohidratos: 0,
      proteinas: 0,
      grasas: 0
    }

    for(let programaComida of this.formConstructorDieta.get('programacionComidas')['controls']) {
      //obtener index de la posicion que se esta recorriendo
      const indexProgramaComida = this.formConstructorDieta.get('programacionComidas')['controls'].indexOf(programaComida);
      for(let ingrediente of programaComida.get('detalle')['controls']) {
        // Calculo del platillo actual
        if(ingrediente.get('nombre').value != 'Comida Libre') {
          if(indexProgramaComida == this.programacionComidaSelected) {
            calculoPlatillo.calorias += Number(ingrediente.value.calorias);
            calculoPlatillo.carbohidratos += Number(ingrediente.value.carbohidratos);
            calculoPlatillo.proteinas += Number(ingrediente.value.proteinas);
            calculoPlatillo.grasas += Number(ingrediente.value.grasaTotal);
          }

          // Calculo de la dieta total
          calculoDieta.calorias += Number(ingrediente.value.calorias);
          calculoDieta.carbohidratos += Number(ingrediente.value.carbohidratos);
          calculoDieta.proteinas += Number(ingrediente.value.proteinas);
          calculoDieta.grasas += Number(ingrediente.value.grasaTotal);
        }
      }
    }
  
    // Calcula el porcentaje de cada macronutriente
    let porcentajesPlatillo = {
      carbohidratos: 0,
      proteinas: 0,
      grasas: 0
    }
    // calcular porcentaje y agregar validación de que si es igual a Nan sea 0
    porcentajesPlatillo.carbohidratos = ((calculoPlatillo.carbohidratos * 4) / calculoPlatillo.calorias) * 100 || 0;
    porcentajesPlatillo.proteinas = ((calculoPlatillo.proteinas * 4) / calculoPlatillo.calorias) * 100 || 0;
    porcentajesPlatillo.grasas = ((calculoPlatillo.grasas * 9) / calculoPlatillo.calorias) * 100 || 0;

    let porcentajesDieta = {
      carbohidratos: 0,
      proteinas: 0,
      grasas: 0
    }
    porcentajesDieta.carbohidratos = ((calculoDieta.carbohidratos * 4) / calculoDieta.calorias) * 100 || 0;
    porcentajesDieta.proteinas = ((calculoDieta.proteinas * 4) / calculoDieta.calorias) * 100 || 0;
    porcentajesDieta.grasas = ((calculoDieta.grasas * 9) / calculoDieta.calorias) * 100 || 0;

    
    // Ajusta los porcentajes para que sumen 100%
    let sumaPorcentajesPlatillo = porcentajesPlatillo.carbohidratos + porcentajesPlatillo.proteinas + porcentajesPlatillo.grasas;
    porcentajesPlatillo.carbohidratos = (porcentajesPlatillo.carbohidratos / sumaPorcentajesPlatillo) * 100;
    porcentajesPlatillo.proteinas = (porcentajesPlatillo.proteinas / sumaPorcentajesPlatillo) * 100;
    porcentajesPlatillo.grasas = (porcentajesPlatillo.grasas / sumaPorcentajesPlatillo) * 100;

    let sumaPorcentajesDieta = porcentajesDieta.carbohidratos + porcentajesDieta.proteinas + porcentajesDieta.grasas;
    porcentajesDieta.carbohidratos = (porcentajesDieta.carbohidratos / sumaPorcentajesDieta) * 100;
    porcentajesDieta.proteinas = (porcentajesDieta.proteinas / sumaPorcentajesDieta) * 100;
    porcentajesDieta.grasas = (porcentajesDieta.grasas / sumaPorcentajesDieta) * 100;

    
    // actualiza form del array de programacionComidas
    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    programacionComidasArray.at(this.programacionComidaSelected).patchValue({
      calorias: calculoPlatillo.calorias,
      carbohidratos: calculoPlatillo.carbohidratos,
      proteinas: calculoPlatillo.proteinas,
      grasas: calculoPlatillo.grasas,
    });
    // actualiza el form de la dieta
    this.formConstructorDieta.patchValue({
      calorias: calculoDieta.calorias,
      carbohidratos: calculoDieta.carbohidratos,
      proteinas: calculoDieta.proteinas,
      grasas: calculoDieta.grasas,
    });

    // Crea el gráfico con los porcentajes calculados
    this.createPieCharts('pieChartPlatilloDieta','pieChartDieta', porcentajesPlatillo, porcentajesDieta);
  }
  
  createPieCharts(pieChartPlatillo: string, pieChartDieta: string, porcentajesPlatillo: any, porcentajesDieta: any): void {
    const ctxPlatillo = document.getElementById(pieChartPlatillo) as HTMLCanvasElement;
    const ctxDieta = document.getElementById(pieChartDieta) as HTMLCanvasElement;
  
    // 📌 Destruir gráficos anteriores si existen
    if (this.chartDietaInstance) {
      this.chartDietaInstance.destroy();
    }
    if (this.chartPlatilloDietaInstance) {
      this.chartPlatilloDietaInstance.destroy();
    }
  
    // 📌 Definir los datos y opciones en una variable para reutilizar
    porcentajesPlatillo.carbohidratos = Number.isNaN(porcentajesPlatillo.carbohidratos) ? 0 : porcentajesPlatillo.carbohidratos;
    porcentajesPlatillo.proteinas = Number.isNaN(porcentajesPlatillo.proteinas) ? 0 : porcentajesPlatillo.proteinas;
    porcentajesPlatillo.grasas = Number.isNaN(porcentajesPlatillo.grasas) ? 0 : porcentajesPlatillo.grasas;
    const chartDataPlatillo = {
      labels: [
        `Carbohidratos ${porcentajesPlatillo.carbohidratos.toFixed(2)}%`,
        `Proteínas ${porcentajesPlatillo.proteinas.toFixed(2)}%`,
        `Grasas ${porcentajesPlatillo.grasas.toFixed(2)}%`
      ],
      datasets: [{
        label: '%',
        data: [porcentajesPlatillo.carbohidratos, porcentajesPlatillo.proteinas, porcentajesPlatillo.grasas],
        backgroundColor: ['rgb(75, 192, 75)', 'rgb(255, 206, 86)', 'rgb(243, 78, 78)'],
        borderColor: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
        borderWidth: 1
      }]
    };
    porcentajesDieta.carbohidratos = Number.isNaN(porcentajesDieta.carbohidratos) ? 0 : porcentajesDieta.carbohidratos;
    porcentajesDieta.proteinas = Number.isNaN(porcentajesDieta.proteinas) ? 0 : porcentajesDieta.proteinas;
    porcentajesDieta.grasas = Number.isNaN(porcentajesDieta.grasas) ? 0 : porcentajesDieta.grasas;
    const chartDataDieta = {
      labels: [
        `Carbohidratos ${porcentajesDieta.carbohidratos.toFixed(2)}%`,
        `Proteínas ${porcentajesDieta.proteinas.toFixed(2)}%`,
        `Grasas ${porcentajesDieta.grasas.toFixed(2)}%`
      ],
      datasets: [{
        label: '%',
        data: [porcentajesDieta.carbohidratos, porcentajesDieta.proteinas, porcentajesDieta.grasas],
        backgroundColor: ['rgb(75, 192, 75)', 'rgb(255, 206, 86)', 'rgb(243, 78, 78)'],
        borderColor: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
        borderWidth: 1
      }]
    };
  
    const chartOptions: ChartOptions = {
      responsive: true,
      plugins: {
        legend: { position: 'top' },
        tooltip: { enabled: true }
      }
    };
  
    // 📌 Crear gráfico de platillo
    this.chartPlatilloDietaInstance = new Chart(ctxPlatillo, {
      type: 'pie',
      data: chartDataPlatillo,
      options: chartOptions
    });
    // 📌 Crear gráfico de dieta
    this.chartDietaInstance = new Chart(ctxDieta, {
      type: 'pie',
      data: chartDataDieta,
      options: chartOptions
    });
  }
  
  // Método para inicializar (o resetear) el gráfico
  inicializarChart(): void {
    const ctx1 = document.getElementById('pieChartDieta') as HTMLCanvasElement;
    const ctx2 = document.getElementById('pieChartPlatilloDieta') as HTMLCanvasElement;

    // Destruye el gráfico anterior si existe
    if (this.chartPlatilloDietaInstance) {
      this.chartPlatilloDietaInstance.destroy();
      this.chartPlatilloDietaInstance = null; // Limpiar referencia
    }

    if (this.chartDietaInstance) {
      this.chartDietaInstance.destroy();
      this.chartDietaInstance = null; // Limpiar referencia
    }

    // Opcionalmente, puedes dejar el lienzo vacío o con un mensaje predeterminado
    const emptyData = {
      labels: [],
      datasets: [{
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      }],
    };

    this.chartPlatilloDietaInstance = new Chart(ctx1, {
      type: 'pie',
      data: emptyData,
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false, // Oculta la leyenda en el gráfico vacío
          },
          tooltip: {
            enabled: false, // Desactiva los tooltips en el gráfico vacío
          }
        }
      } as ChartOptions,
    });

    this.chartDietaInstance = new Chart(ctx2, {
      type: 'pie',
      data: emptyData,
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false, // Oculta la leyenda en el gráfico vacío
          },
          tooltip: {
            enabled: false, // Desactiva los tooltips en el gráfico vacío
          }
        }
      } as ChartOptions,
    });
  }

  disableBtnGuardarDieta() {
    if(this.formConstructorDieta.invalid) return true;

    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    let existeAlimento: boolean = false
    for(let comida of programacionComidasArray.controls) {
      if(comida.get('detalle').value.length > 0) {
        if(comida.get('nombre').value != '') {
          existeAlimento = true;
        } else if(comida.get('nombre').value == '') {
          existeAlimento = false;
          break;
        }
      }
    }
    if(!existeAlimento) return true;

    return false;
  }
  validarFormConstructorDieta(guardarEn: 'biblioteca' | 'periodo')
  {
    if(this.formConstructorDieta.invalid){
      Swal.fire('Advertencia', 'Verifica que los campos sean válidos.', 'warning');
      return;
    }

    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    let existeAlimento: boolean = false
    for(let comida of programacionComidasArray.controls) {
      if(comida.get('detalle').value.length > 0) {
        if(comida.get('nombre').value != '') {
          existeAlimento = true;
          break;
        } else {
          Swal.fire('Advertencia', 'Agrega un nombre a la comida.', 'warning');
          return;
        }
      }
    }
    if(!existeAlimento) {
      Swal.fire('Advertencia', 'Agrega por lo menos un alimento.', 'warning');
      return;
    }
    this.setDietaDocument(guardarEn);
  }
  setDietaDocument(guardarEn: 'biblioteca' | 'periodo')
  {
    // setear el array de programacionComidas solo los que tengan alimentos
    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    let programacionComidas = programacionComidasArray.value.filter((comida: any) => comida.detalle.length > 0);

    let dietaDocModel: any = {
      activo: true,
      nombre: this.formConstructorDieta.get('nombre').value,
      programacionComidas: programacionComidas,
      calorias: this.formConstructorDieta.get('calorias').value,
      carbohidratos: this.formConstructorDieta.get('carbohidratos').value,
      proteinas: this.formConstructorDieta.get('proteinas').value,
      grasas: this.formConstructorDieta.get('grasas').value,
      propietario: this.userInfo.documentContainerId,
      empresaId: this.userInfo.empresaId
    }
    console.log('dietaDocModel', dietaDocModel)

    // Verifica si existe el documento de la dieta
    let dietaEncontrada
    if(guardarEn == 'biblioteca') dietaEncontrada = this.listaDietas.find(d => d.nombre === dietaDocModel.nombre);
    if(guardarEn == 'periodo') dietaEncontrada = this.dietasPeriodoActivo.find(d => d.nombre === dietaDocModel.nombre);
    // console.log('dietaEncontrada', dietaEncontrada)
    if(dietaEncontrada) {
      Swal.fire({
        title: 'Advertencia',
        html: 'Ya existe una dieta con el nombre: <b>"'+dietaDocModel.nombre+'"</b>.<br>¿Desea actualizarla?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar'
      }).then((result) => {
        if (result.isConfirmed) { // Solo se ejecuta si el usuario confirma
          dietaDocModel.documentId = dietaEncontrada.documentId; 
          this.updateDietaFn(dietaDocModel, dietaEncontrada.documentId, guardarEn);
        } else {
          return; // No hace nada si el usuario cancela
        }
      });
    } else {
      // Si no existe, crea una nueva dieta
      this.createDietaFn(dietaDocModel, guardarEn);
    }
  }


  /****************** CREAR DIETA *****************/
  createDietaFn(dietaDocModel: any, guardarEn: 'biblioteca' | 'periodo') { 
    // console.log('===> createDietaFn', dietaDocModel)
    if(guardarEn == 'periodo') {
      dietaDocModel.programaId = this.programaId;
    }
    // console.log('dietaDocModel', dietaDocModel)
    this.documentService.createDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      null,
      this.patternDietas,
      null,
      dietaDocModel,
    ).subscribe({
      next: (data) => {
        console.log('data createDieta', data);
        Swal.fire({
          toast: true,
          position: 'bottom-end',
          icon: 'success',
          title: 'Dieta creada correctamente.',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true
        });

        this.getDietas();
        this.limpiarFormConstructorDieta(true);


        if(guardarEn == 'periodo') {
          if(this.clienteId){
            let programas = [...this.detalleCliente.expediente.programas];
            const indexPrograma = programas.findIndex((item) => item.configuracionPrograma.id == this.detallePrograma?.configuracionPrograma.id);

            let periodo = {...programas[indexPrograma].periodos[this.filtroPeriodoActivo]};
            console.log('periodo', periodo)

            let dieta: any = {nombre: dietaDocModel.nombre, documentId: data.documentId};
            if(!programas[indexPrograma].periodos[this.filtroPeriodoActivo].dietas) programas[indexPrograma].periodos[this.filtroPeriodoActivo].dietas = [];
            programas[indexPrograma].periodos[this.filtroPeriodoActivo].dietas.push(dieta);

            this.updateClienteDocument(programas);
          } else {
            let periodos = [...this.detallePrograma.periodos];
            let dieta: any = {nombre: dietaDocModel.nombre, documentId: data.documentId};

            if(!periodos[this.filtroPeriodoActivo].dietas) periodos[this.filtroPeriodoActivo].dietas = [];
            periodos[this.filtroPeriodoActivo].dietas.push(dieta);

            this.updateProgramaDocument(periodos);
          }
        }
      },error: (error) => {
        console.error(error);
        Swal.fire('Error', 'Error al crear la dieta.', 'error');
      },
    });
  }
  /****************** EDITAR DIETA *****************/
  updateDietaFn(dietaDocModel: any, documentId: string, guardarEn: 'biblioteca' | 'periodo') {
    // console.log('===> updateDietaFn', dietaDocModel)
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      documentId,
      this.patternDietas,
      null,
      dietaDocModel,
    ).subscribe({
      next: (data) => {
        console.log('data updateDieta', data);
        Swal.fire({
          toast: true,
          position: 'bottom-end',
          icon: 'success',
          title: 'Dieta actualizada correctamente.',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true
        });
        this.getDietas();
        this.limpiarFormConstructorDieta(true);

        if(guardarEn == 'periodo') {
          let periodos = [...this.detallePrograma.periodos];
          const index = periodos[this.filtroPeriodoActivo].dietas.findIndex(d => d.documentId == documentId);
          if(index == -1) {
            Swal.fire('Error', 'La dieta no se encuentra en el periodo.', 'error');
          } else {
            periodos[this.filtroPeriodoActivo].dietas.splice(index, 1);
          }
          this.updateProgramaDocument(periodos);
        }
      },error: (error) => {
        console.error(error);
        Swal.fire('Error', 'Error al actualizar la dieta.', 'error');
      },
    });
  }
  /****************** ELIMINAR DIETA *****************/
  deleteDietaFn(dietaDocModel: any, guardarEn: 'biblioteca' | 'periodo') {
    // console.log('===> deleteDietaFn', dietaDocModel)
    let title: string = 'Eliminar dieta';
    let html: string = '¿Seguro que desea eliminar la dieta: <b>"'+dietaDocModel.nombre+'"</b>?';
    if(guardarEn == 'periodo') {
      title = 'Eliminar dieta del periodo';
      html = '¿Seguro que desea eliminar la dieta: <b>"'+dietaDocModel.nombre+'"</b> del periodo?';
    }

    Swal.fire({
      title: title,
      html: html,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        dietaDocModel.activo = false;
        console.log(dietaDocModel)
        this.updateDietaFn(dietaDocModel, dietaDocModel.documentId, guardarEn);
      }
    })
  }
  /****************** ACTUALIZAR PERIODO DE PROGRAMA *****************/
  updateProgramaDocument(periodos)
  {
    // console.log('====> updateProgramaDocument', periodos)
    let programaDocument: any = {};
    programaDocument = {
      periodos: periodos
    }
    // console.log('--> programaDocument',programaDocument)
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.detallePrograma.documentId,
      "programa",
      null,
      programaDocument
    ).subscribe({
      next: (data: any) => {
        // console.log('updateProgramaDocument DATA', data);
        this.getDetallePrograma(this.programaId);
        Swal.fire({
          toast: true, // Activa el estilo tipo Toast
          position: 'bottom-end', // Posición del mensaje
          icon: 'success',
          title: 'Periodo actualizado con éxito.',
          showConfirmButton: false,
          timer: 3000, // Tiempo de duración del mensaje (3 segundos)
          timerProgressBar: true // Muestra una barra de progreso
        });
      },
      error: (error) => {
        console.log(error);
      }
    })
  }
  /****************** ACTUALIZAR CLIENTE *****************/
  updateClienteDocument(programas)
  {
    // console.log('====> updateClienteDocument', programas)
    let expedienteClienteDocument: any = {
      expediente: { 
        programas: programas
      }
    }
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.detalleCliente.documentId,
      "cliente",
      null,
      expedienteClienteDocument
    ).subscribe({
      next: (data: any) => {
        console.log(data);
        this.getDetalleCliente();
        this.inicializarDataTableDietasActivas();

        Swal.fire({
          toast: true, // Activa el estilo tipo Toast
          position: 'bottom-end', // Posición del mensaje
          icon: 'success',
          title: 'Periodo actualizado con éxito.',
          showConfirmButton: false,
          timer: 3000, // Tiempo de duración del mensaje (3 segundos)
          timerProgressBar: true // Muestra una barra de progreso
        });
      },
      error: (error) => {
        console.log(error);
      }
    })
  }
  
  /**************** FUN PARA SUBIR IMAGENES POR PROGRAMA DE COMIDA *****************/
  fileChangeEvent(event: any, comidaIndex: number): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      
      // Actualizar el estado de la imagen para esta comida
      this.imageStates[comidaIndex].imageChangedEvent = event;
      this.imageStates[comidaIndex].bolCroppedImg = true;

      const reader = new FileReader();
      reader.onload = () => {
        this.imageStates[comidaIndex].rawFile = {
          file: reader.result,
          type: file.type,
          name: file.name
        };
      };
      reader.readAsBinaryString(file);
    }
  }
  imageCropped(event: ImageCroppedEvent, comidaIndex: number) {
    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    const comida = programacionComidasArray.at(comidaIndex);
    
    this.imageStates[comidaIndex].croppedImage = event.base64 || '';

    // Subir la imagen recortada inmediatamente
    if (event.base64) {
      const croppedImage = event.base64.replace(/^data:.+;base64,/, '');
      const rawFile = this.imageStates[comidaIndex].rawFile;

      this.uploadService.uploadImage(
        environment.businessId,
        this.utilsService.create_UUID(),
        rawFile.name,
        croppedImage,
        rawFile.type
      ).subscribe({
        next: (fileData: any) => {
          // Actualizar el formGroup con la URL de la imagen
          comida.patchValue({
            imagen: {
              url: fileData.fileName,
              nombre: rawFile.name
            }
          });
          console.log('Imagen subida:', fileData.fileName);
        },
        error: (error) => {
          console.error('Error uploading image:', error);
        }
      });
    }
  }
  // Funciones auxiliares para el manejo de imágenes
  imageLoaded(comidaIndex: number) {
    console.log('Image loaded for comida:', comidaIndex);
  }
  cropperReady(event: any, comidaIndex: number) {
    console.log('Cropper ready for comida:', comidaIndex);
  }
  loadImageFailed(comidaIndex: number) {
    console.error('Failed to load image for comida:', comidaIndex);
    this.deleteImage(comidaIndex);
  }
  deleteImage(comidaIndex: number) {
    // Resetear el estado de la imagen para esta comida
    this.imageStates[comidaIndex] = {
      imageChangedEvent: '',
      croppedImage: '',
      bolCroppedImg: false,
      rawFile: null,
      previewUrl: null
    };

    // Limpiar la imagen en el formGroup
    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    const comida = programacionComidasArray.at(comidaIndex);
    comida.patchValue({
      imagen: null
    });
    // console.log('Imagen eliminada para comida:', comidaIndex);
    // console.log('formConstructorDieta', this.formConstructorDieta.value)
  }

  /**************************************************/
  /********** AGREGAR ELEMENTOS A PLATILLO **********/
  /**************************************************/
  /************** Funciones para agregar|editar|eliminar platillo **************/
  modalGuardarPlatillo() {
    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    this.dataPlatillo.nombre = programacionComidasArray.at(this.programacionComidaSelected).get('nombre').value;
    this.dataPlatillo.categoria = '';
    $('#modal-guardarPlatillo').modal({backdrop: 'static', keyboard: false})
    $("#modal-guardarPlatillo").modal('show');
  }
  createOrUpdatePlatilloFn()
  {
    const programacionComidasArray = this.formConstructorDieta.get('programacionComidas') as FormArray;
    let platilloDocModel: PlatilloModel = {
      activo:        true,
      nombre:        this.dataPlatillo.nombre,
      descripcion:   programacionComidasArray.at(this.programacionComidaSelected).get('descripcion').value,
      // imagen:        imagen,
      categoria:     this.dataPlatillo.categoria,
      detalle:       programacionComidasArray.at(this.programacionComidaSelected).get('detalle').value,
      calorias:      programacionComidasArray.at(this.programacionComidaSelected).get('calorias').value,
      carbohidratos: programacionComidasArray.at(this.programacionComidaSelected).get('carbohidratos').value,
      proteinas:     programacionComidasArray.at(this.programacionComidaSelected).get('proteinas').value,
      grasas:        programacionComidasArray.at(this.programacionComidaSelected).get('grasas').value,
      imagen:        programacionComidasArray.at(this.programacionComidaSelected).get('imagen').value,
      propietario:   this.userInfo.documentContainerId,
      empresaId:     this.userInfo.empresaId
    }
    console.log('platilloDocModel', platilloDocModel)

    // Busca en listado de platillos propios si existe el platillo
    let platilloEncontrado;
    platilloEncontrado = this.listaPlatillosPropios.find(p => p.nombre === platilloDocModel.nombre);
    if (platilloEncontrado) {
      console.log('platilloEncontrado', platilloEncontrado)
      Swal.fire({
        title: 'Advertencia',
        html: 'Ya existe un platillo con el nombre: <b>"'+platilloDocModel.nombre+'"</b>.<br>¿Desea actualizarlo?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar'
      }).then((result) => {
        if (result.isConfirmed) { // Solo se ejecuta si el usuario confirma
            platilloDocModel.documentId = platilloEncontrado.documentId; 
            this.updatePlatilloFn(platilloDocModel, platilloEncontrado.documentId);
        } else {
          return; // No hace nada si el usuario cancela
        }
      });
    } else {
      this.createPlatilloFn(platilloDocModel);
    }
  }
  createPlatilloFn(platilloDocModel) {
    // console.log('createPlatilloFn - platilloDocModel', platilloDocModel)
    this.documentService.createDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
      null,
      this.patternPlatillos,
      null,
      platilloDocModel,
    ).subscribe({
      next: (data) => {
        console.log('data createPlatillo', data);
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Platillo guardado con éxito",
          showConfirmButton: false,
          timer: 1500
        });
        this.getPlatillos();
        $("#modal-guardarPlatillo").modal('hide');
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  updatePlatilloFn(platilloDocModel, documentId) {
    let title = ''
    if(platilloDocModel.activo) title = "Platillo actualizado con éxito";
    if(!platilloDocModel.activo) title = "Platillo eliminado con éxito";
    // console.log('updatePlatilloFn - platilloDocModel', platilloDocModel)

    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
      documentId,
      this.patternPlatillos,
      null,
      platilloDocModel
    ).subscribe({
      next: (data) => {
        console.log(data);
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: title,
          showConfirmButton: false,
          timer: 1500
        });
        this.getPlatillos();
        $("#modal-guardarPlatillo").modal('hide');
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  /********* ELIMINAR PLATILLO *******/
  deletePlatilloFn(platilloDocModel) {
    Swal.fire({
      title: 'Eliminar platillo',
      html: '¿Seguro que desea eliminar la platillo: <b>"'+platilloDocModel.nombre+'"</b>?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        platilloDocModel.objInfo.activo = false;
        console.log(platilloDocModel)
        this.updatePlatilloFn(platilloDocModel.objInfo, platilloDocModel.objInfo.documentId);
      }
    })
  }
  
  /*************** DETALLE PLATILLO ***************/
  detallePlatillo: any = {};
  modalDetallePlatilo(platillo)
  {
    // console.log(platillo)
    this.detallePlatillo = platillo;

    let caloriasPlatillo = platillo.cal;
    let carbohidratosPlatillo = platillo.gC;
    let proteinasPlatillo = platillo.gP;
    let grasasPlatillo = platillo.gG;
  
    // Calcula el porcentaje de cada macronutriente
    let porcentajeCarbohidratos = ((carbohidratosPlatillo * 4) / caloriasPlatillo) * 100 || 0;
    let porcentajeProteinas = ((proteinasPlatillo * 4) / caloriasPlatillo) * 100 || 0;
    let porcentajeGrasas = ((grasasPlatillo * 9) / caloriasPlatillo) * 100 || 0;

    // Ajusta los porcentajes para que sumen 100%
    let sumaPorcentajes = porcentajeCarbohidratos + porcentajeProteinas + porcentajeGrasas;
    porcentajeCarbohidratos = (porcentajeCarbohidratos / sumaPorcentajes) * 100;
    porcentajeProteinas = (porcentajeProteinas / sumaPorcentajes) * 100;
    porcentajeGrasas = (porcentajeGrasas / sumaPorcentajes) * 100;
  
    // Crea el gráfico con los porcentajes calculados
    // this.createPieChartPlatilloOriginal('pieChartDetallePlatillo', porcentajeCarbohidratos, porcentajeProteinas, porcentajeGrasas);

    $('#modal-detallePlatillo').modal({backdrop: 'static', keyboard: false})
    $("#modal-detallePlatillo").modal('show');
  }
  
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === '-' || event.key === 'Subtract' || event.key === '+' || event.key === 'Add') {
      event.preventDefault(); // Evita que se ingrese el signo "-"
    }
  }
}
